/* eslint-disable import/no-extraneous-dependencies */
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import ShippingAdress from '../../../../components/Web/ShippingInfo/redesign/ShippingAdress';
import * as shippingInfoActions from '../../actions';
import injectReducer from '../../../../utils/injectReducer';
import injectSaga from '../../../../utils/injectSaga';
import saga from '../../sagas';
import paymentInfo from '../../../PaymentInfo/sagas';
import shippingInfo from '../../reducer';
import * as ContactInfoActions from '../../../ContactInfo/actions';
import * as shippingInfoSelectors from '../../selectors/shippingInfoSelectors';
import * as cartActions from '../../../../services/Cart/actions';
import * as paymentActions from '../../../PaymentInfo/actions';
import * as creditCheckActions from '../../../CreditCheck/actions';
import creditCheckSaga from '../../../CreditCheck/sagas';
// import { compareAddressInfo } from '../../../../components/common/addressUtils';

// import { getCreditHoldStatus } from '../../../../services/Cart/selectors/cartSelectors';
const mapStateToProps = (state) => {
  const shippingInfoSelector = shippingInfoSelectors.selectShippingData(state);
  const shippingInfoState = state.shippingInfo;
  const { shippingInvalidError, apiFailureError } = shippingInfoState;
  const currentView = state.currentView || {};
  const shippingInfoDetails = state.shippingInfo.ShippingInfoDetails || {};
  const sddSlots = state.shippingInfo.sddSlots || {};
  const selectedShippingOption = state.shippingInfo.selectedShippingOption || {};
  const securePinData = state.shippingInfo.securePinData || {};
  const cartDetails = state.cartDetails && state.cartDetails.cartDetailsJson ? state.cartDetails.cartDetailsJson : {};
  // securePinDataDeviceSucess
  const orderDetails = cartDetails && cartDetails.orderDetailsView ? cartDetails.orderDetailsView : {};
  const securePinDataDeviceSucess = state.shippingInfo.securePinDataDeviceSucess || {};
  const commonData = state.shippingInfo.commonData || {};
  const getSmsSuccess = state.shippingInfo.getSmsSuccess || {};
  const marketDetails = state.shippingInfo.marketDetails || {};
  const shippingAddress = state.cartDetails ? state.cartDetails.cartDetailsJson && state.cartDetails.cartDetailsJson.shippingDetails : {};
  // const shippingOldAddress = state.cartDetails ? state.cartDetails.cartDetailsJson && state.cartDetails.cartDetailsJson.cart5GAddress : {};
  const validateOrder = state?.cartDetails?.validateOrder || {}; // getValidateOrder(state.cartDetails);
  const creditStatus = validateOrder?.orderDetails?.[0] || {};
  const isCreditHold = creditStatus && creditStatus.creditApprovalStatus && creditStatus.creditApprovalStatus !== 'AP'; // getCreditHoldStatus(state.cartDetails);
  const isCreditStatusAvailable =
    isCreditHold || validateOrder.downpaymentRequired || (validateOrder.errorMessage && validateOrder.errorMessage !== '');
  const creditStatusLanded = state.creditStatus?.creditStatusLanded;
  const paymentInfoState = state && state.paymentInfo;
  const paymentOptions = state && state.paymentInfo && state.paymentInfo.data && state.paymentInfo.data.paymentOptions;
  const isBTAAvailable = paymentOptions && paymentOptions.filter((item) => item.paymentType === 'AC');
  let otherPaymentOptions = [];
  let savedcardOption =
    paymentOptions && paymentOptions.filter((item) => item.paymentType === 'CR' && item.savedCCList && item.savedCCList.length !== 0);
  savedcardOption = savedcardOption && savedcardOption.map((obj) => ({ ...obj, paymentType: 'SC' }));
  otherPaymentOptions = paymentOptions && paymentOptions.concat(savedcardOption);
  const isBTAEligible = state && state.shippingInfo && state.shippingInfo.isBTAEligible;
  const isbillingInfoEdited = state.contactInfo && state.contactInfo.billingInfoEdited ? state.contactInfo.billingInfoEdited : false;
  const updateValidateOTPResponse = shippingInfoState?.updateValidateOTPResponse;
  const shippingAddress2UnitCount = state.shippingInfo?.shippingAddress2UnitItems;
  const unitArray = state.shippingInfo?.shippingAddress2UnitArray;
  const shippingAddressEdit = state.shippingInfo?.shippingAddressEdit;
  // const sameAsServiceAddress = compareAddressInfo(cartDetails?.cart5GAddress, shippingAddress?.[0]?.address);
  const sameAsServiceAddress =
    cartDetails?.cart5GAddress?.addressLine1 === shippingAddress?.[0]?.address?.addressLine1 &&
    cartDetails?.cart5GAddress?.city === shippingAddress?.[0]?.address?.city &&
    cartDetails?.cart5GAddress?.state === shippingAddress?.[0]?.address?.state &&
    cartDetails?.cart5GAddress?.zipCode === shippingAddress?.[0]?.address?.zipCode;

  const showPickupInfoTab = state.shippingInfo?.showPickupInfoTab;

  // email validation
  const isEmailSuccess = state.shippingInfo ? state.shippingInfo.emailAPiResponse : {};
  const { accMainEmailVal } = state.shippingInfo;
  const { emailMaxAttempts } = state.shippingInfo;
  const creditReviewSuccessResponse = state.creditCheckDetails?.creditReviewSuccessResponse?.serviceResponse?.context?.cartInfo;
  const { availableAddressUnit } = state.cartDetails;
  const ISPUSelectedStoreFromModel = state.shippingInfo?.ISPUSelectedStoreFromModel;

  return {
    ISPUSelectedStoreFromModel,
    shippingInfoSelector,
    currentView,
    orderDetails,
    shippingInfoState,
    shippingInfoDetails,
    selectedShippingOption: selectedShippingOption || {},
    sddSlots,
    securePinData,
    securePinDataDeviceSucess,
    getSmsSuccess,
    shippingAddress,
    cartDetails,
    commonData,
    marketDetails,
    isCreditStatusAvailable,
    creditStatusLanded,
    paymentInfoState,
    isBTAAvailable,
    isBTAEligible,
    otherPaymentOptions,
    isbillingInfoEdited,
    updateValidateOTPResponse,
    isEmailSuccess,
    accMainEmailVal,
    emailMaxAttempts,
    addressList: state?.cartDetails?.availableAddress ? state?.cartDetails?.availableAddress?.addresses : [],
    unitlist: state?.cartDetails?.availableAddressUnit2 ? state?.cartDetails?.availableAddressUnit2?.data : [],
    appConfigValue: state?.cartDetails?.appConfig ? state?.cartDetails?.appConfig : false,
    isEmptyAddress: state?.cartDetails?.isEmptyAddress || false,
    isPOBoxAddress: state?.cartDetails?.isPOBoxAddress || false,
    shippingInvalidError,
    apiFailureError,
    creditReviewSuccessResponse,
    availableAddressUnit,
    shippingAddress2UnitCount,
    unitArray,
    shippingAddressEdit,
    sameAsServiceAddress,
    showPickupInfoTab,
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      ...shippingInfoActions,
      ...cartActions,
      ...ContactInfoActions,
      ...paymentActions,
      ...creditCheckActions,
    },
    dispatch,
  );
}

const withReducer = compose(
  injectReducer({ key: 'shippingInfo', reducer: shippingInfo }),
  injectSaga({ key: 'paymentInfo', saga: paymentInfo }),
  injectSaga({ key: 'creditCheck', saga: creditCheckSaga }),
);

const withConnect = connect(mapStateToProps, mapDispatchToProps);

const withSaga = injectSaga({ key: 'shippingInfo', saga });
export default withRouter(compose(withSaga, withReducer, withConnect)(ShippingAdress));
